(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["legacy-room-ideas"] && !Shopify.designMode) return;
  try {
    
  function initializeRoomIdeasFilters() {
    document.querySelectorAll('[data-room-ideas-filters]').forEach((filters) => {
      if (filters.dataset.roomIdeasFiltersInitialized === 'true') {
        return;
      }

      filters.dataset.roomIdeasFiltersInitialized = 'true';

      const filterLinks = Array.from(filters.querySelectorAll('[data-room-filter]'));
      const cards = Array.from(document.querySelectorAll('[data-room-card]'));
      const selectedTitle = new URLSearchParams(window.location.search).get('title');
      let didDrag = false;
      let isMouseDown = false;
      let startScrollLeft = 0;
      let startX = 0;
      let suppressClickUntil = 0;

      const applyFilter = (selectedFilter) => {
        filterLinks.forEach((filterLink) => {
          const isSelected = filterLink.dataset.roomFilter === selectedFilter;
          filterLink.classList.toggle('is-active', isSelected);
          filterLink.setAttribute('aria-current', isSelected ? 'page' : 'false');
        });

        cards.forEach((card) => {
          const tags = (card.dataset.roomTag || '').split(',').map((tag) => tag.trim());
          card.hidden = selectedFilter !== 'all' && !tags.includes(selectedFilter);
        });
      };

      const initialFilterLink = filterLinks.find((filterLink) => filterLink.dataset.roomFilter === selectedTitle);
      applyFilter(initialFilterLink ? selectedTitle : 'all');

      filters.addEventListener('mousedown', (event) => {
        if (event.button !== 0) {
          return;
        }

        didDrag = false;
        isMouseDown = true;
        startScrollLeft = filters.scrollLeft;
        startX = event.clientX;
      });

      window.addEventListener('mousemove', (event) => {
        if (!isMouseDown) {
          return;
        }

        const distance = event.clientX - startX;

        if (Math.abs(distance) > 8) {
          didDrag = true;
          filters.classList.add('is-dragging');
          filters.scrollLeft = startScrollLeft - distance;
          event.preventDefault();
        }
      });

      window.addEventListener('mouseup', () => {
        if (!isMouseDown) {
          return;
        }

        if (didDrag) {
          suppressClickUntil = Date.now() + 150;
        }

        didDrag = false;
        isMouseDown = false;
        filters.classList.remove('is-dragging');
      });

      filters.addEventListener('dragstart', (event) => {
        event.preventDefault();
      });

      filterLinks.forEach((filterLink) => {
        filterLink.addEventListener('click', (event) => {
          if (Date.now() < suppressClickUntil) {
            event.preventDefault();
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeRoomIdeasFilters, { once: true });
  } else {
    initializeRoomIdeasFilters();
  }

  } catch(e) { console.error(e); }
})();
})();
